import { all, takeLatest, call, put } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import { auth as authService } from 'services';
import { logoutSuccess, logoutFailure } from './actions';
import { LogoutLocalActionTypes } from './types';

export function* handleLogout() {
  try {
    const response: AxiosResponse = yield call(authService.logout);
    if (response?.data) {
      yield put(logoutSuccess());
    } else {
      yield put(logoutFailure('Unable to fetch User Teams'));
    }
  } catch (error) {
    yield put(logoutFailure('Unable to fetch User Teams'));
  }
}

export function* onLogout() {
  yield takeLatest(LogoutLocalActionTypes.LOGOUT_START, handleLogout);
}

export function* sagas() {
  yield all([call(onLogout)]);
}

export default sagas;
